export class PhoneVerificationReqRes {
  phone:string;
  phoneVerificationSentDate: Date;
  isPhoneVerified: boolean;
  error: PhoneVerificationErrorType;
}

export enum PhoneVerificationErrorType {
  None = 0,
  MaxNumberOfSmsExceeded = 1,
  CodeExpired = 2,
  InvalidCode = 3
}
